import React from 'react';
import { SimpleCrudManager } from '../components/SimpleCrudManager';

export function CollectionsPage() {
  return (
    <SimpleCrudManager
      title="Collections"
      subtitle="Manage kit collections (e.g. New Collection) — a kit belongs to at most one"
      apiPath="collections"
      itemNoun="Collection"
      responseKey="collections"
    />
  );
}